import "./styles.less";
import { SurfaceRangeFilterProps, useSurfaceRange } from "./SurfaceRange.hook";
import { formatMoney } from "../../../Utils/Functions";
import { IC_Collapse } from "shared-components/Components/Collapse/web";
import ButtonGroup from "../ButtonGroup/web";
import { getSurfaceRange } from "shared-components/ViewFragments/SearchResults/Sider/TopBarFilters/options";
import { CloseIcon } from "shared-components/Components/CustomIcons/CloseIcon/web";
import { useContext } from "react";
import { ConfigStateContext } from "shared-components/Contexts/Configurations/context";
import { firstLetterToUppercase } from "src/utils/Functions";
import { useWindowSize } from "shared-components/GlobalHooks/useWindowSize";

const SurfaceRange = ({
	collapsable = false,
	labeled = false,
	triggerApplyFilter,
	show,
	...props
}: SurfaceRangeFilterProps) => {
	if (!show) return null;

	const {	translations } = useContext(ConfigStateContext);
	const {
		m2Min,
		m2Max,
		m2Type,
		isActive,
		errorMessage,
		saveFilter,
		cleanSurfaceFilter
	} = useSurfaceRange({...props, triggerApplyFilter});
	const surfaceRange = getSurfaceRange(translations);
	const screens = useWindowSize()
	const isMobile =  !screens.xl && !screens.lg;

	const handleMeterTypeChange = (value) => {
		m2Type.set(value);
	}

	const handleMeterMinChange = (e) => {
        const formattedValue = e.target.value.replace(/\D/g, '')
		m2Min.set(formattedValue);
	}

	const handleMeterMaxChange = (e) => {
        const formattedValue = e.target.value.replace(/\D/g, '')
		m2Max.set(formattedValue);
	}

	const meterType = (
		<ButtonGroup
			options={surfaceRange}
			selected={[m2Type.value ?? surfaceRange[0].value]}
			allowMuliple={false}
			onChange={handleMeterTypeChange}
			isSmall
		/>
	);

	const range = (
		<div className="metersRange">
            <div className='priceRange__box'>
				<input
					type="text"
					value={m2Min.value ? formatMoney(m2Min.value) : ""}
					placeholder="Min"
					onChange={handleMeterMinChange}
					onBlur={() => {
						if (m2Min.value) saveFilter()
					}}
					onKeyDown={(e) => {
						if (e.key === 'Enter') {
							saveFilter();
						}
					}}
				/>
 
				<button
					className={`priceRange__box-clear ${!m2Min.value ? "hidden" : ""}`}
					style={{padding: 5}}
					onClick={() => cleanSurfaceFilter('m2Min')}
				>
					<CloseIcon width={10} />
				</button>
			</div>

            <span>-</span>

            <div className='priceRange__box'>
				<input
					type="text" 
					value={m2Max.value ? formatMoney(m2Max.value) : ""}
					placeholder="Max"
					onChange={handleMeterMaxChange}
					onBlur={() => {
						if (m2Max.value) saveFilter()
					}}
					onKeyDown={(e) => {
						if (e.key === 'Enter') {
							saveFilter();
						}
					}}
				/>

				<button
					className={`priceRange__box-clear ${!m2Max.value ? "hidden" : ""}`}
					style={{padding: 5}}
					onClick={() => cleanSurfaceFilter('m2Max')}
				>
					<CloseIcon width={10} />
				</button>
			</div>
        </div>
	);

	const error = (
		errorMessage && (
			<p className="error-message">{errorMessage}</p>
		)
	)

	const filter = (
		<>
			{meterType}
			{range}
			{error}
		</>
	);

	const label = firstLetterToUppercase(translations.area);

	//Validación error max menor que min

	return (
		<div className="filter m2Type-filter">
			{collapsable ?
				<IC_Collapse label={label} isActive={isActive}>
					{filter}
				</IC_Collapse> :
				<>
					<h3 className="filter-title">{label}</h3>
					{filter}
					<hr style={{width:"100%", border:'none', borderTop:'1px solid rgba(0,0,0,.06)', margin:'24px 0'}} />
				</>
			}
		</div>
	);
};

export { SurfaceRange };
